import { SupportingDocumentField } from "../utils/useCheckingProfileValidations";
import { SupportingDocumentHandler } from "./SupportingDocumentHandler";

export function DocumentUploadSection({
  fields,
}: {
  fields: SupportingDocumentField[];
}) {
  return (
    <div className="space-y-4 xl:columns-2">
      {fields.map((field) => (
        <SupportingDocumentHandler key={field.code} field={field} />
      ))}
    </div>
  );
}
